import $ from 'jquery';

var _datasetPreviewTimeout = null;
var _datasetPreviewVisible = false;

function showDatasetPreviewForFile(filename, rect) {
  var panel = document.getElementById('dataset-hover-preview');
  if (!panel) return;

  var left = rect.right + 12;
  var top = rect.top;
  var panelWidth = 420;

  if (left + panelWidth > window.innerWidth - 8) {
    left = Math.max(8, rect.left - panelWidth - 12);
  }
  if (top + 320 > window.innerHeight - 8) {
    top = Math.max(8, window.innerHeight - 328);
  }

  panel.style.left = left + 'px';
  panel.style.top = top + 'px';
  panel.style.display = 'block';
  panel.innerHTML = '<div style="padding:8px;color:#aaa;font-size:12px">Loading preview...</div>';
  _datasetPreviewVisible = true;

  var secret = (window.userData && window.userData.secret) || '';
  if (!secret) {
    panel.innerHTML = '<div style="padding:8px;color:#aaa;font-size:12px">Sign in to preview</div>';
    return;
  }

  var url = '/api/dataset-preview?secret=' + encodeURIComponent(secret) +
            '&filename=' + encodeURIComponent(filename) + '&rows=10';

  fetch(url)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!_datasetPreviewVisible) return;
      if (!data.columns || !data.rows) {
        panel.innerHTML = '<div style="padding:8px;color:#aaa;font-size:12px">Preview unavailable</div>';
        return;
      }
      var html = '<div class="preview-header"><strong>' + escapeHtml(filename) + '</strong>' +
                 ' <span style="color:#aaa;font-size:11px">' + (data.row_count || '?') + ' rows</span></div>' +
                 '<div style="overflow:auto;max-height:270px">' +
                 '<table class="preview-table"><thead><tr>';
      data.columns.forEach(function(col) {
        html += '<th>' + escapeHtml(String(col)) + '</th>';
      });
      html += '</tr></thead><tbody>';
      data.rows.forEach(function(row) {
        html += '<tr>';
        data.columns.forEach(function(col) {
          html += '<td>' + escapeHtml(String(row[col] !== undefined ? row[col] : '')) + '</td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table></div>';
      panel.innerHTML = html;
    })
    .catch(function() {
      if (_datasetPreviewVisible) {
        panel.innerHTML = '<div style="padding:8px;color:#aaa;font-size:12px">Preview unavailable</div>';
      }
    });
}

function hideDatasetPreview() {
  _datasetPreviewVisible = false;
  var panel = document.getElementById('dataset-hover-preview');
  if (panel) panel.style.display = 'none';
}

function setupDialogs() {
  var dialog = document.querySelector('dialog');
  if (!dialog || !dialog.showModal) {
    return;
    //todo polyfill>?
  }

  // Setup subscribe dialog
  var subscribeDialog = document.getElementById('subscribe-dialog');
  if (subscribeDialog) {
    subscribeDialog.querySelector('.close').addEventListener('click', function () {
      subscribeDialog.close();
      resetMessageCount();
    });

    // Setup billing switcher functionality
    $('.billing-switcher').click(function () {
      var isChecked = $(this).find('input').prop('checked');
      if (isChecked) {
        $('.money-amount-pro').text('$19 USD');
        $('.annual-price').html(
          '(<b class="money-amount money-amount-pro2">$228 USD</b> billed annually)'
        );
        $('#subscribe-dialog input[name="type"]').val('annual');
      } else {
        $('.money-amount-pro').text('$29 USD');
        $('.annual-price').html('');
        $('#subscribe-dialog input[name="type"]').val('monthly');
      }
    });
  }

  dialog.querySelector('.close').addEventListener('click', function () {
    dialog.close();
  });

  $('#add-dash-btn').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    // Skip the naming modal: auto-name and create immediately. Rename inline
    // in the sidebar (double-click or long-press) afterwards.
    $('#dashname').val('');
    $('#submitNewDashForm').trigger('submit');
    return false;
  });
  $('#add-chat-btn').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    // Skip the naming modal: auto-name and create immediately. Rename inline
    // in the sidebar (double-click or long-press) afterwards.
    $('#chatname').val('');
    $('#submitNewChatForm').trigger('submit');
    return false;
  });
  $('.close').click(function (event) {
    // get parent dialog element by name
    var dialog = $(this).parents('dialog').get(0);
    dialog.close();
    event.preventDefault();
    event.stopPropagation();
    $('#treeView .file').removeClass('active'); // disaple selected datasets on close - is this right long term??
    return false;
  });
}

var curentEditingFileName = '';

function isSupportedFileType(fileName) {
  var allTypes = fixtures.all_types;
  for (var i = 0; i < allTypes.length; i++) {
    if (fileName.endsWith('.' + allTypes[i])) {
      return true;
    }
  }
  return false;
}

function renderFailedUploads(userData) {
  for (var i = 0; i < userData.processed_file_names.length; i++) {
    var fileName = userData.processed_file_names[i];

    var displayFileName = fileName.replace('.broken', '');
    let isNotSupportedFileType = !isSupportedFileType(displayFileName);
    let isBrokenFile = fileName.endsWith('.broken');
    if (isBrokenFile || isNotSupportedFileType) {
      displayFileName = displayFileName.split('-').slice(1).join('-');
      var fileNode = $('#treeView')
        .find('.file-name:contains("' + displayFileName + '")')
        .parent();
      // find the arrow icon

      var tooltiprandomID = Math.random().toString(36).substring(7);
      let $statusIcon = fileNode.find('.file-status-icon');
      $statusIcon.text('warning');
      $statusIcon.addClass('file-status-icon--visible');
      var fileExtensionName = displayFileName.split('.').pop();

      fileNode.attr('id', tooltiprandomID);
      // append is dangerous, but we are sure that the tooltip is not there yet
      var message = isNotSupportedFileType
        ? 'I dont know ' + fileExtensionName + ' files yet'
        : "Sorry I couldn't understand<br>My developer will fix me.";
      fileNode.parent()
        .append(`<div class="mdl-tooltip-larger mdl-tooltip mdl-tooltip--large" for="${tooltiprandomID}">
                  <img id="ask-felix-robot-icon" class="ask-felix-robot-icon ask-felix-robot-icon--tooltip" src="/static/img/askfelix-robot-icon-transp.webp" alt="A" style="">
                    ${message}
                </div>`);
      $arrowIcon.addClass('broken');

      // fileNode.addClass('broken');
    }
  }
  componentHandler.upgradeDom();
}

function renderExampledatasets() {
  treeView = $('#sampleDatasetTreeView');
  let allExampleData = fixtures.all_example_data;
  if (!allExampleData || !allExampleData.length) {
    return;
  }
  var processed_file_paths = [];
  var fileNames = [];
  for (var i = 0; i < allExampleData.length; i++) {
    var exampleData = allExampleData[i];
    processed_file_paths.push(exampleData.processed_file_path);
    fileNames.push(exampleData.file_name);
  }
  createTreeView(fileNames, '#sampleDatasetTreeView', '', false);
}

// Add message limit tracking
let messageCount = 0;
const MAX_MESSAGES = 5;
function showSubscribeDialog() {
  var subscribeDialog = document.getElementById('subscribe-dialog');
  if (subscribeDialog && !subscribeDialog.open) {
    subscribeDialog.showModal();
  }
}

function checkMessageLimit() {
  messageCount++;
  if (userData.is_subscribed) {
    return true;
  }
  // Enforce a basic message limit for free users
  if (messageCount >= MAX_MESSAGES) {
    showSubscribeDialog();
    return false;
  }
  return true;
}

function resetMessageCount() {
  messageCount = 0;
}

function updateDatasetChip(filename) {
    var container = document.getElementById('dataset-chip-container');
    if (!container) return;
    if (!filename) {
        container.innerHTML = '';
        return;
    }
    container.innerHTML = '<span class="dataset-chip" id="active-dataset-chip">' +
        '<i class="material-icons" style="font-size:14px;vertical-align:middle">storage</i> ' +
        '<span class="chip-label">' + escapeHtml(filename) + '</span>' +
        ' <span class="chip-close" title="Deselect dataset">\u00d7</span>' +
        '</span>';

    // Click chip label -> reopen edit dialog
    container.querySelector('.chip-label').addEventListener('click', function() {
        var active = document.querySelector('#treeView .file.active');
        if (active) active.click();
    });

    // Click X -> clear selection
    container.querySelector('.chip-close').addEventListener('click', function(e) {
        e.stopPropagation();
        $('#treeView .file').removeClass('active');
        container.innerHTML = '';
        document.dispatchEvent(new CustomEvent('dataset:selected', { detail: { filename: null } }));
    });
}

function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

window.updateDatasetChip = updateDatasetChip;

function refreshFileTree(data) {
  if (!data) {
    return dataAccessor.getAllFiles().then(refreshFileTree);
  }
  var fileNames = (data.files || []).map(x =>
    x.indexOf('-') > -1 ? x.slice(x.indexOf('-') + 1) : x
  );
  var folders = data.folders || data.folder_names || [];
  createTreeView(fileNames, '#treeView', '', true, folders);
  renderFailedUploads(data);
}

// Expose a decoupled refresh hook so other modules (e.g. datadisplay after a
// deep-linked dataset query auto-adds a dataset server-side) can repopulate the
// "my datasets" tree without a hard import. Re-fetches from the server so the
// freshly auto-added file shows up immediately.
window.refreshFileTree = refreshFileTree;
document.addEventListener('datasets:refresh', function () {
  try {
    refreshFileTree();
  } catch (e) {
    console.warn('datasets:refresh handler failed', e);
  }
});

$(document).ready(function () {
  // Default to the expanded sidebar. Only restore compact mode after the user
  // explicitly chooses it, and never force the icon rail on narrow screens.
  var railStored = null;
  try {
    railStored = localStorage.getItem('helix_sidebar_compact');
  } catch (storageError) {
    console.warn('Could not read the sidebar preference', storageError);
  }
  var compact = railStored === '1' && window.matchMedia('(min-width: 1025px)').matches;
  document.body.classList.toggle('sidebar-compact', compact);
  var railIcon = document.getElementById('sidebar-rail-icon');
  if (railIcon) railIcon.textContent = compact ? 'menu' : 'menu_open';
  var railToggle = document.getElementById('sidebar-rail-toggle');
  if (railToggle) railToggle.setAttribute('aria-expanded', String(!compact));

  // Sidebar rail toggle
  $(document).on('click', '#sidebar-rail-toggle', function() {
    var isCompact = document.body.classList.toggle('sidebar-compact');
    try {
      localStorage.setItem('helix_sidebar_compact', isCompact ? '1' : '0');
    } catch (storageError) {
      console.warn('Could not save the sidebar preference', storageError);
    }
    var railIcon = document.getElementById('sidebar-rail-icon');
    if (railIcon) railIcon.textContent = isCompact ? 'menu' : 'menu_open';
    this.setAttribute('aria-expanded', String(!isCompact));
  });

  // Whole-row click on sidebar section headers (Chats/Dashboards/Datasets/Data Connectors).
  // Clicks on the secondary action (+ / search button) retain their own handlers.
  function runSidebarHeaderAction(action) {
    switch (action) {
      case 'add-chat':       $('#add-chat-btn').trigger('click'); break;
      case 'add-dash':       $('#add-dash-btn').trigger('click'); break;
      case 'add-connector':
        if (window.DataConnectors && typeof window.DataConnectors.open === 'function') {
          window.DataConnectors.open();
        } else {
          document.querySelector('#add-connector-btn')?.click();
        }
        break;
      case 'browse-datasets': window.location.href = '/datasets'; break;
      case 'upload-dataset': $('#new-ai-avatar').trigger('click'); break;
    }
  }
  $(document).on('click', '[data-mobile-action]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    runSidebarHeaderAction(this.getAttribute('data-mobile-action'));
  });
  $(document).on('click', '.sidebar-section-header', function (event) {
    if ($(event.target).closest('.mdl-list__item-secondary-content').length) return;
    var action = this.getAttribute('data-sidebar-action');
    if (!action) return;
    event.preventDefault();
    runSidebarHeaderAction(action);
  });
  $(document).on('keydown', '.sidebar-section-header', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if ($(event.target).closest('.mdl-list__item-secondary-content').length) return;
    var action = this.getAttribute('data-sidebar-action');
    if (!action) return;
    event.preventDefault();
    runSidebarHeaderAction(action);
  });

  setupDialogs();
  renderExampledatasets();

  $('#create-folder-button').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    var name = prompt('Folder name');
    if (!name) {
      return false;
    }
    dataAccessor.createFolder(name).then(refreshFileTree);
    return false;
  });
  $(document).on('click', '#treeView .file', async function (evt) {
    // todo temp disable everything?

    curentEditingFileName = $(this).find('.file-name').text();
    // Notify other components about dataset selection
    document.dispatchEvent(new CustomEvent('dataset:selected', { detail: { filename: curentEditingFileName } }));
    updateDatasetChip(curentEditingFileName);
    // disable all active others
    $('#treeView .file').removeClass('active');
    $(this).addClass('active');
    //open the dialog
    var dialog = document.getElementById('edit-data-dialog');
    if (dialog.open) dialog.close();
    dialog.showModal();
    // todo show spinner?
    var filePath = dataAccessor.getFilePathByFileName(curentEditingFileName);
    if (window.NativeDatasetEditor && typeof window.NativeDatasetEditor.openDataset === 'function') {
      window.NativeDatasetEditor.openDataset({ filename: curentEditingFileName, filePath: filePath });
    }
  });

  $(document).on('click', '#sampleDatasetTreeView .file', async function (evt) {
    // todo temp disable everything?
    curentEditingFileName = $(this).find('.file-name').text();
    let allExampleData = fixtures.all_example_data;
    var processed_file_paths = [];
    var file_names = [];
    for (var i = 0; i < allExampleData.length; i++) {
      var exampleData = allExampleData[i];
      processed_file_paths.push(exampleData.processed_file_path);
      file_names.push(exampleData.file_name);
    }
    var filePath = dataAccessor.getFilePathByFileName(
      curentEditingFileName,
      processed_file_paths,
      file_names
    );
    dataAccessor.saveAllNewFiles([filePath]);
    document.dispatchEvent(new CustomEvent('dataset:selected', { detail: { filename: curentEditingFileName } }));
    updateDatasetChip(curentEditingFileName);

    // disable all active others
    $('#treeView .file').removeClass('active');
    $(this).addClass('active');
    //open the dialog
    var dialog = document.getElementById('edit-data-dialog');
    if (dialog.open) dialog.close();
    dialog.showModal();
    // todo show spinner?
    if (window.NativeDatasetEditor && typeof window.NativeDatasetEditor.openDataset === 'function') {
      window.NativeDatasetEditor.openDataset({ filename: curentEditingFileName, filePath: filePath });
    }
  });

  // The native dataset editor owns this form. Keep the quota check available
  // to it without coupling the editor to this module's private state.
  window.checkDatasetEditMessageLimit = checkMessageLimit;

  //hookup edit form for data

  // Dataset hover preview handlers
  $(document).on('mouseenter', '#treeView .file', function() {
    var el = this;
    var filename = $(el).find('.file-name').text().trim();
    if (!filename) return;
    var rect = el.getBoundingClientRect();
    clearTimeout(_datasetPreviewTimeout);
    _datasetPreviewTimeout = setTimeout(function() {
      showDatasetPreviewForFile(filename, rect);
    }, 400);
  });

  $(document).on('mouseleave', '#treeView .file', function() {
    clearTimeout(_datasetPreviewTimeout);
    setTimeout(function() {
      var panel = document.getElementById('dataset-hover-preview');
      if (panel && !panel.matches(':hover')) {
        hideDatasetPreview();
      }
    }, 150);
  });

  $(document).on('mouseleave', '#dataset-hover-preview', function() {
    hideDatasetPreview();
  });

  // Use SimpleAuth instead of Firebase
  $(document).on('user-ready', function (event, userData) {
    // Support both native CustomEvent(detail) and jQuery trigger(extraParams)
    const data = userData || (event && event.detail) || window.userData;
    if (data && data.secret) {
      // User is signed in with SimpleAuth
      var displayName = data.name;
      var email = data.email;
      var emailVerified = true; // SimpleAuth users are verified through login
      var photoURL = null; // Not available in SimpleAuth
      var uid = data.id;
      var phoneNumber = null; // Not available in SimpleAuth
      var providerData = null; // Not needed in SimpleAuth

      // Ensure we get name in the user object
      if (!displayName && email) {
        displayName = email.split('@')[0]; // Extract name from email if not provided
      }

      // Create user object compatible with existing code
      const user = {
        email: email,
        displayName: displayName,
        uid: uid,
        secret: data.secret
      };

      getUser(user, function (userDataFromServer) {
        // todo enable upload files dialog
        // todo dedupe calls to get user
        if (userDataFromServer.file_names && userDataFromServer.file_names.length > 0) {
          refreshFileTree(userDataFromServer);
          // createTreeView(userData.dashboards, "#dashboardTreeView", "dashboard");
        }
        $('#datasets-spinner').hide();
      });
      //TODO err handler ?
      window.user = user;
    } else {
      console.log('User not logged in - showing datasets options without redirect');
      // User is signed out.
      $('#datasets-spinner').hide(); // Hide spinner when user is not logged in
    }
  });
});

// $(document).ready(function () {
//   getAllFiles();
// }
